module.exports = __webpack_public_path__ + "img/color-gradient-1_en.6ea0825.jpg";